(function() {
    Localization.$inject = ['$scope'];

	angular
		.module('app')
		.component('localization', {
			templateUrl: 'modules/localization/pages/localization.html',
			controller: Localization,
			 bindings: {
                permissions: '<'
            }
		});

	function Localization($scope) {

		var perms = this.permissions;
        $scope.pagePermissions = [];

        // rewrite the permissions array to be easily checked
        for (var i = 0; i < perms.length; i++){     
            $scope.pagePermissions[perms[i]] = true;
        } 

        if (typeof($scope.pagePermissions.write) == 'undefined'){
           
            $scope.pagePermissions.write = false;
        }
	}
})();